import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
import { GroupContext } from "./useGroupContext.js";
function Group({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(GroupContext.Provider, {
    value: "group",
    children: /* @__PURE__ */ jsx(GroupStyled, {
      ...props,
      children
    })
  });
}
const GroupStyled = styled.div.withConfig({
  displayName: "GroupStyled",
  componentId: "sc-1o6r33c-0"
})(["margin:0;padding:", " 0;border:0;"], token.spacing3);
export {
  Group
};
//# sourceMappingURL=Group.js.map
